/**
 * @file 校区管理页 · 类型与 mock
 * @description 校区列表本地模拟数据；暂不接真实接口。
 *
 * @whenToUse 仅校区管理页。
 * @whenNotToUse 其他业务模块。
 */

/** 校区行 */
export type CampusRow = {
  /** 校区 ID */
  id: string
  /** 校区名称 */
  name: string
  /** 主账号 */
  account: string
  /** 点数 */
  points: number
  /** 教师人数 */
  teacherCount: number
  /** 学员人数 */
  studentCount: number
  /** 创建时间 */
  createdAt: string
  /** 是否启用 */
  enabled: boolean
}

/** 新建 / 编辑表单 */
export type CampusFormValues = {
  /** 校区名称 */
  name: string
  /** 校区主账号 */
  account: string
  /** 主账号密码；编辑时可空表示不改 */
  password: string
  /** 点数 */
  points: number
}

/** 成员（教师 / 学员）简表 */
export type CampusMember = {
  /** 成员 ID */
  id: string
  /** 姓名 */
  name: string
  /** 手机号 */
  phone: string
}

/** 充值 / 扣除记录 */
export type CampusRechargeRecord = {
  /** 记录 ID */
  id: string
  /** 变动点数；正数为充值，负数为扣除 */
  points: number
  /** 时间 */
  createdAt: string
  /** 备注 */
  remark: string
}

/** 初始三条 mock 校区 */
export const MOCK_CAMPUSES: CampusRow[] = [
  {
    id: '1',
    name: '徐汇校区',
    account: 'xuhui_admin',
    points: 1200,
    teacherCount: 8,
    studentCount: 126,
    createdAt: '2025-11-02 10:20:00',
    enabled: true,
  },
  {
    id: '2',
    name: '浦东校区',
    account: 'pudong_admin',
    points: 100,
    teacherCount: 5,
    studentCount: 98,
    createdAt: '2026-01-15 14:05:00',
    enabled: true,
  },
  {
    id: '3',
    name: '闵行校区',
    account: 'minhang_admin',
    points: 0,
    teacherCount: 3,
    studentCount: 54,
    createdAt: '2026-03-08 09:40:00',
    enabled: false,
  },
]

/** mock 教师 */
export const MOCK_TEACHERS: Record<string, CampusMember[]> = {
  '1': [
    { id: 't1', name: '张老师', phone: '13800001111' },
    { id: 't2', name: '李老师', phone: '13800002222' },
  ],
  '2': [{ id: 't3', name: '王老师', phone: '13800003333' }],
  '3': [{ id: 't4', name: '赵老师', phone: '13800004444' }],
}

/** mock 学员 */
export const MOCK_STUDENTS: Record<string, CampusMember[]> = {
  '1': [
    { id: 's1', name: '小明', phone: '13900001111' },
    { id: 's2', name: '小红', phone: '13900002222' },
  ],
  '2': [{ id: 's3', name: '小刚', phone: '13900003333' }],
  '3': [{ id: 's4', name: '小丽', phone: '13900004444' }],
}

/** mock 充值记录 */
export const MOCK_RECHARGE_RECORDS: Record<string, CampusRechargeRecord[]> = {
  '1': [
    {
      id: 'r1',
      points: 500,
      createdAt: '2026-06-01 11:00:00',
      remark: '学期初充值',
    },
  ],
  '2': [
    {
      id: 'r2',
      points: 300,
      createdAt: '2026-05-20 16:30:00',
      remark: '活动赠送',
    },
  ],
  '3': [],
}

/** 空表单默认值 */
export const EMPTY_CAMPUS_FORM: CampusFormValues = {
  name: '',
  account: '',
  password: '',
  points: 0,
}
